import { apiClient } from "@/lib/api-client"
import {
  DocumentPermissionDto,
  GrantDocumentPermissionRequest,
} from "../dtos/DocumentPermissionDto"
import { BulkShareRequest, BulkShareResult } from "../dtos/BulkPermissionDtos"

export const documentPermissionService = {
  getDocumentPermissions: async (
    organizationId: string,
    documentId: string,
  ): Promise<DocumentPermissionDto[]> => {
    const response = await apiClient.get<DocumentPermissionDto[]>(
      `/organizations/${organizationId}/documents/${documentId}/permissions`,
    )
    return response.data
  },

  grantDocumentPermission: async (
    organizationId: string,
    documentId: string,
    request: GrantDocumentPermissionRequest,
  ): Promise<DocumentPermissionDto> => {
    const response = await apiClient.post<DocumentPermissionDto>(
      `/organizations/${organizationId}/documents/${documentId}/permissions`,
      request,
    )
    return response.data
  },

  revokeDocumentPermission: async (
    organizationId: string,
    permissionId: string,
  ): Promise<void> => {
    await apiClient.delete(
      `/organizations/${organizationId}/documents/permissions/${permissionId}`,
    )
  },

  bulkGrantDocumentPermissions: async (
    organizationId: string,
    documentId: string,
    request: BulkShareRequest,
  ): Promise<BulkShareResult> => {
    const response = await apiClient.post<BulkShareResult>(
      `/organizations/${organizationId}/documents/${documentId}/permissions/bulk`,
      request,
    )
    return response.data
  },
}
